// extracted by mini-css-extract-plugin
export default {"pageContentContainerLayout":"PageContentContainerLayout_pageContentContainerLayout__HgkNZ"};